// EXTERNAL
import React from "react";
// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// CONTEXT
import { useCreativeDispatch, useCreativeState } from "../../../../contexts/creative.context";
import { useNotificationDispatch } from "../../../../contexts/notification.context";
// CONFIGS
import studio_config from "../../../../configs/studio.json";
// TYPES
import { StudioConfig } from "../types";
import { Slide } from "../../../../types/contextType";

interface FormatMenuProps {
  applicableFormats: string[];
  adSize: string;
}

export function FormatMenu({ applicableFormats, adSize }: FormatMenuProps) {
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();
  const notificationDispatch = useNotificationDispatch();
  const studioConfig: StudioConfig = studio_config;

  return (
    <>
      <ComponentLibrary.PCHeader text={"Ad Format"} />
      <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={4} />
      <ComponentLibrary.PCFormatMenu
        handleChange={(formatChoice: string) => {
          const containsImage = creative.metadata.slides.find((slide: Slide) => slide.media.mimeType.includes("image"));
          if (formatChoice === "clips" && containsImage) {
            return notificationDispatch({
              type: "ADD",
              payload: {
                header: "Error",
                message: "Clips accepts video formats only. Please delete any images to continue.",
                type: "error",
                autoDismiss: false,
              },
            });
          }

          creativeDispatch({
            type: "UPDATE_CREATIVE_METADATA_FORMAT",
            payload: { format: formatChoice },
          });
          /**
           * JA (18-08-23)
           * When a format is selected, update the aspect ratio to the value that is associated with the selected ad size.
           */
          creativeDispatch({
            type: "UPDATE_CREATIVE_METADATA_ASPECTRATIO",
            payload: { aspectRatio: studioConfig.formats[formatChoice].media.frameRatios.find((option: FrameRatio) => option.adSize === adSize).name },
          });
          /**
           *  Hide emoji reactions section if unsupported format
           */
          creativeDispatch({
            type: "UPDATE_CREATIVE_METADATA_FEATURES_REACTIONS_VISIBLE",
            payload: { visible: studioConfig.formats[formatChoice].inputs.features.reactions.supported ? creative.metadata.features.reactions.visible : false },
          });
        }}
        selected={creative.metadata.format}
        activeFormats={studioConfig.activeFormats}
        applicableFormats={applicableFormats}
      />
    </>
  );
}
